import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import api from "@/lib/api";

const errText = (d) => (typeof d === "string" ? d : Array.isArray(d) ? d.map((e) => e.msg).join(" ") : "Could not update password");

export const ChangePasswordModal = ({ open, onOpenChange }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const reset = () => { setCurrent(""); setNext(""); setConfirm(""); };
  const handleOpenChange = (o) => { if (!o) reset(); onOpenChange(o); };

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) return toast.error("New password must be at least 8 characters.");
    if (next !== confirm) return toast.error("New passwords don't match.");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      reset();
      onOpenChange(false);
    } catch (err) {
      toast.error(errText(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  const field = "bg-white/[0.03] border-white/10 text-slate-100";
  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="bg-[#0b0c10] border-white/10 text-slate-100" data-testid="change-password-modal">
        <DialogHeader>
          <DialogTitle className="font-heading uppercase tracking-tight">Change password</DialogTitle>
          <DialogDescription className="text-slate-400">Use at least 8 characters.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="flex flex-col gap-3">
          <Input type="password" autoComplete="current-password" aria-label="Current password" placeholder="Current password" value={current} onChange={(e) => setCurrent(e.target.value)} className={field} data-testid="current-password-input" />
          <Input type="password" autoComplete="new-password" aria-label="New password" placeholder="New password" value={next} onChange={(e) => setNext(e.target.value)} className={field} data-testid="new-password-input" />
          <Input type="password" autoComplete="new-password" aria-label="Confirm new password" placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={field} data-testid="confirm-password-input" />
          <Button type="submit" disabled={saving} className="bg-[#00f0ff] text-black hover:bg-[#33f4ff]" data-testid="change-password-submit">
            {saving ? "Saving…" : "Update password"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
